import { createContext, useEffect, useState } from 'react';
import { listenForPushNotifications } from '../utilities/PushNotifier';

export const PushNotificationsContext = createContext({
  pushNotificationJobUrl: null,
  setPushNotificationJobUrl: () => {},
});

export default function PushNotifications({ children }) {
  const [pushNotificationJobUrl, setPushNotificationJobUrl] = useState(null);

  useEffect(() => {
    listenForPushNotifications(setPushNotificationJobUrl);
  }, []);

  return (
    <PushNotificationsContext.Provider value={{ pushNotificationJobUrl }}>
      { children }
    </PushNotificationsContext.Provider>
  );
}
